import React from "react";

import { ModalClose } from "~/components/classLanding/components/HeroSection/ClassTrailerVideoModal/ModalClose";

export const ModalCloseButton = ({
  onClick,
  className,
    width,
    height
}: {
  onClick: () => void;
  className: string;
  width?: number,
  height?: number
}): React.ReactElement => {
  return (
    <button onClick={onClick} aria-label="Close pop-up" className={`modal-x-button ${className}`}>
      <ModalClose width={width} height={height} />
    </button>
  );
};
